export default {
  en: {
    logout: 'Log out',
    title: 'Profile',
    noName: 'No name',
    sectionLearning: 'Learning',
    personalization: 'Personalization',
    mistakes: 'Mistakes',
    subscription: 'Subscription',
    settings: 'Settings',
    documents: 'Documents',
    support: 'Support',
    guestTitle: 'Save your progress',
    guestSubtitle: 'Sign in with Yandex ID or VK ID',
    premiumTitle: 'Get Premium',
    premiumSubtitle: 'Everything you need to speak freely',
  },
  ru: {
    logout: 'Выйти',
    title: 'Профиль',
    noName: 'Без имени',
    sectionLearning: 'Обучение',
    personalization: 'Персонализация',
    mistakes: 'Ошибки',
    subscription: 'Подписка',
    settings: 'Настройки',
    documents: 'Документы',
    support: 'Поддержка',
    guestTitle: 'Сохрани прогресс',
    guestSubtitle: 'Войди через Яндекс ID или VK ID',
    premiumTitle: 'Подключить Премиум',
    premiumSubtitle: 'Всё, чтобы заговорить свободно',
  },
  de: {
    logout: 'Abmelden',
    title: 'Profil',
    noName: 'Ohne Namen',
    sectionLearning: 'Lernen',
    personalization: 'Personalisierung',
    mistakes: 'Fehler',
    subscription: 'Abo',
    settings: 'Einstellungen',
    documents: 'Dokumente',
    support: 'Support',
    premiumTitle: 'Premium holen',
    premiumSubtitle: 'Alles, um frei zu sprechen',
  },
  pt: {
    logout: 'Sair',
    title: 'Perfil',
    noName: 'Sem nome',
    sectionLearning: 'Aprendizado',
    personalization: 'Personalização',
    mistakes: 'Erros',
    subscription: 'Assinatura',
    settings: 'Configurações',
    documents: 'Documentos',
    support: 'Suporte',
    premiumTitle: 'Assinar o Premium',
    premiumSubtitle: 'Tudo para você falar com liberdade',
  },
  fr: {
    logout: 'Se déconnecter',
    title: 'Profil',
    noName: 'Sans nom',
    sectionLearning: 'Apprentissage',
    personalization: 'Personnalisation',
    mistakes: 'Erreurs',
    subscription: 'Abonnement',
    settings: 'Paramètres',
    documents: 'Documents',
    support: 'Assistance',
    premiumTitle: 'Passer à Premium',
    premiumSubtitle: 'Tout pour parler librement',
  },
  es: {
    logout: 'Cerrar sesión',
    title: 'Perfil',
    noName: 'Sin nombre',
    sectionLearning: 'Aprendizaje',
    personalization: 'Personalización',
    mistakes: 'Errores',
    subscription: 'Suscripción',
    settings: 'Ajustes',
    documents: 'Documentos',
    support: 'Soporte',
    premiumTitle: 'Obtener Premium',
    premiumSubtitle: 'Todo para hablar con soltura',
  },
};
